const ACCOUNT_CREATION_DISABLED_ENV_KEY = "VITE_DISABLE_ACCOUNT_CREATION";

function readEnvFlag(key: string, env?: Record<string, string | undefined>): string | undefined {
  if (env) return env[key];
  const importMetaEnv = (import.meta as { env?: Record<string, string | undefined> }).env;
  const processEnv = (
    globalThis as {
      process?: { env?: Record<string, string | undefined> };
    }
  ).process?.env;
  return importMetaEnv?.[key] ?? processEnv?.[key];
}

export function isAccountCreationDisabled(env?: Record<string, string | undefined>) {
  return readEnvFlag(ACCOUNT_CREATION_DISABLED_ENV_KEY, env) === "true";
}

export const ACCOUNT_CREATION_DISABLED_NOTICE =
  "Account creation is disabled while the site is under development.";
